import React from 'react'
import PropTypes from 'prop-types'
import { germanCharacters } from '../../common/config'

// TODO keyboard for more languages
const Keyboard = ({ lessonId, wordId, word, lang, cursorIndex, textChange }) => (
  <div className="keyboard">
    {
      lang === 'de' &&
      germanCharacters.map(ch => (
        <button
          key={ch}
          onClick={() =>
            textChange(lessonId, wordId, `${word.slice(0, cursorIndex)}${ch}${word.slice(cursorIndex)}`)
          }
        >
          {ch}
        </button>
      ))
    }
  </div>
)

Keyboard.propTypes = {
  textChange: PropTypes.func.isRequired,
  lessonId: PropTypes.string.isRequired,
  word: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  wordId: PropTypes.number.isRequired,
  cursorIndex: PropTypes.number.isRequired,
}

export default Keyboard



// WEBPACK FOOTER //
// ./src/browser/components/Keyboard.js